import {Component, inject} from '@angular/core';
import {Location, NgClass} from "@angular/common";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {PaddockStore} from 'src/app/domain/assets/paddocks/paddock.store';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {Router} from '@angular/router';
import {FarmService} from 'src/app/domain/assets/farm/farm.service';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';

@Component({
  selector: 'app-add-paddocks',
  imports: [
    NgClass
],
  templateUrl: './add-paddocks.component.html',
  styleUrl: './add-paddocks.component.css'
})
export class AddPaddocksComponent {

  paddockStore = inject(PaddockStore);

  private farmStore = inject(FarmStore);
  private location = inject(Location);
  private mainViewStore = inject(MainViewStore);
  private router = inject(Router);

  constructor(
    private dataSubscriptionService: DataSubscriptionService,
    private farmService: FarmService,
    protected viewportService: ViewportService
  ) {}

  back(): void {
    this.location.back();
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }

  setKmlFile(event: HTMLInputElement) {
    const farmId = this.farmStore.farm()?.id;
    if (!farmId) return;

    const files = event.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    this.farmService.addPaddocks(farmId, file);

    this.router.navigate(['/main/paddocks']);
  }
}
